import React, { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeaderImage from "../assets/images/rooms/header.jpg";
import KingIndoorImage from "../assets/images/rooms/kingindoor/1.jpg";
import GalleryImage1 from "../assets/images/rooms/kingindoor/screens/1.jpg";
import GalleryImage2 from "../assets/images/rooms/kingindoor/screens/2.jpg";
import GalleryImage3 from "../assets/images/rooms/kingindoor/screens/3.jpg";
import GalleryImage4 from "../assets/images/rooms/kingindoor/screens/4.jpg";
import GalleryImage5 from "../assets/images/rooms/kingindoor/screens/5.jpg";
import GalleryImage6 from "../assets/images/rooms/kingindoor/screens/6.jpg";
import GalleryImage7 from "../assets/images/rooms/kingindoor/screens/7.jpg";
import GalleryImage8 from "../assets/images/rooms/kingindoor/screens/8.jpg";
import GalleryImage9 from "../assets/images/rooms/kingindoor/screens/9.jpg";
import GalleryImage10 from "../assets/images/rooms/kingindoor/screens/10.jpg";
import GalleryImage11 from "../assets/images/rooms/kingindoor/screens/11.jpg";

// External stylesheets
const stylesheets = [
  "https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&ver=6.0.1",
  "https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&ver=6.0.1",
  "https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap",
  "https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap",
  "https://fonts.googleapis.com/css2?family=Poetsen+One&display=swap",
  "/pettipetti/css/bootstrap.min.css",
  "/bbmirissa/css/style.css",
  "/pettipetti/css/secondary/style.css",
  "/pettipetti/css/vendors.min.css",
  "/pettipetti/css/custom.css",
];

const Kingroomin = () => {
  const [roomAmount, setRoomAmount] = useState(1);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);

  const today = new Date();
  const formattedDate = today
    .toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    .toUpperCase();
  const dateFormatStart = today
    .toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();
  const dateFormatEnd = today
    .toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();

  const originalImages = [
    { src: GalleryImage1, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage2, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage3, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage4, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage5, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage6, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage7, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage8, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage9, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage10, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
    { src: GalleryImage11, alt: "", title: "Bunk beds in Banana Bunk Mirissa" },
  ];

  const galleryImages = [
    ...originalImages,
    ...originalImages,
    ...originalImages,
  ];

  // Handle room and guest selection
  // const handleRoomChange = (increment) => {
  //   setRoomAmount((prev) => Math.max(1, prev + increment));
  // };

  // const handleAdultChange = (increment) => {
  //   setAdults((prev) => Math.max(1, prev + increment));
  // };

  // const handleChildrenChange = (increment) => {
  //   setChildren((prev) => Math.max(0, prev + increment));
  // };

  const sliderRef = useRef(null);
  const slidesRef = useRef(null);
  const [translate, setTranslate] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [prevTranslate, setPrevTranslate] = useState(0);
  const [singleSetWidth, setSingleSetWidth] = useState(0);
  const [liWidth, setLiWidth] = useState(0);

  // Load Font Awesome for icons
  // useEffect(() => {
  //   const faScript = document.createElement('script');
  //   faScript.src = 'https://kit.fontawesome.com/a076d05399.js';
  //   faScript.crossOrigin = 'anonymous';
  //   document.head.appendChild(faScript);

  //   const scripts = [
  //     'https://ajax.googleapis.com/ajax/libs/jquery/2.1.1/jquery.min.js',
  //     '/bbmirissa/js/script.js',
  //     '/bbmirissa/js/common_scripts.js',
  //     '/bbmirissa/js/common_functions.js',
  //     '/bbmirissa/js/slider.js',
  //   ];

  //   const loadedScripts = scripts.map((url) => {
  //     const script = document.createElement('script');
  //     script.src = url;
  //     script.async = true;
  //     document.body.appendChild(script);
  //     return script;
  //   });

  //   return () => {
  //     document.head.removeChild(faScript);
  //     loadedScripts.forEach((script) => {
  //       document.body.removeChild(script);
  //     });
  //   };
  // }, []);

  useEffect(() => {
    if (slidesRef.current) {
      const li = slidesRef.current.children[0];
      const computedStyle = getComputedStyle(li);
      const marginLeft = parseInt(computedStyle.marginLeft);
      const marginRight = parseInt(computedStyle.marginRight);
      const width = li.offsetWidth + marginLeft + marginRight;
      setLiWidth(width);
      const single = originalImages.length * width;
      setSingleSetWidth(single);
      setTranslate(-single);
      setPrevTranslate(-single);
    }
  }, []); // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const getClientX = (e) => {
      return e.type.includes("touch") ? e.touches[0].pageX : e.pageX;
    };

    const handleStart = (e) => {
      setIsDragging(true);
      setStartX(getClientX(e));
      setPrevTranslate(translate);
      slider.style.cursor = "grabbing";
    };

    const handleMove = (e) => {
      if (!isDragging) return;
      const currentX = getClientX(e);
      const delta = currentX - startX;
      let newTranslate = prevTranslate + delta;
      if (newTranslate > 0) {
        newTranslate -= singleSetWidth;
        setStartX(currentX);
        setPrevTranslate(newTranslate);
      }
      if (newTranslate < -2 * singleSetWidth) {
        newTranslate += singleSetWidth;
        setStartX(currentX);
        setPrevTranslate(newTranslate);
      }
      setTranslate(newTranslate);
    };

    const handleEnd = () => {
      setIsDragging(false);
      slider.style.cursor = "grab";
    };

    slider.addEventListener("mousedown", handleStart);
    slider.addEventListener("touchstart", handleStart);
    document.addEventListener("mousemove", handleMove);
    document.addEventListener("touchmove", handleMove, { passive: false });
    document.addEventListener("mouseup", handleEnd);
    document.addEventListener("touchend", handleEnd);
    slider.addEventListener("mouseleave", handleEnd);

    return () => {
      slider.removeEventListener("mousedown", handleStart);
      slider.removeEventListener("touchstart", handleStart);
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchend", handleEnd);
      slider.removeEventListener("mouseleave", handleEnd);
    };
  }, [isDragging, translate, startX, prevTranslate, singleSetWidth]);

  return (
    <>
      {stylesheets.map((href, index) => (
        <link
          key={index}
          rel="stylesheet"
          href={href}
          type="text/css"
          media="all"
        />
      ))}
      <title>
        Deluxe King Room with Indoor Spa Bath | Banana Bunks Mirissa | Oryza
        Leisure
      </title>
      <div
        className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox"
        data-home-url=""
      >
        {/* <div id="preloader">
          <div data-loader="circle-side"></div>
        </div> */}

        <style>
          {`
           /* Import Yellowtail font from Google Fonts */
          @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

          .hotale-page-title hotale-additional-font {
            font-family: 'Yellowtail', cursive !important;
            font-style: normal !important;
            font-weight: 400 !important;
            color: rgb(255, 255, 255) !important;
            font-size: 80px !important;
            line-height: 96px !important;
          }

          /* Mobile overrides for font styles */
          @media (max-width: 375px) {
            .hotale-page-title hotale-additional-font {
              font-size: 35px !important; /* Smaller font size for mobile */
              line-height: 56px !important; /* Smaller line height for mobile */
            }
          }
        `}
        </style>
        <Navbar />
        <div
          className="hotale-page-title-wrap hotale-style-custom hotale-center-align"
          style={{ backgroundImage: `url(${HeaderImage})` }}
        >
          <div className="hotale-header-transparent-substitute"></div>
          <div className="hotale-page-title-overlay"></div>
          <div className="hotale-page-title-container hotale-container">
            <div className="hotale-page-title-content hotale-item-pdlr">
              <h1 className="hotale-page-title hotale-additional-font">
                <b>Deluxe King Room with Indoor Spa Bath</b>
              </h1>
            </div>
          </div>
        </div>
        <div
          className="gdlr-core-page-builder-body bbmirissabg"
          style={{ paddingTop: "40px", paddingBottom: "40px" }}
        >
          <div
            className="gdlr-core-pbf-sidebar-wrapper gdlr-core-js"
            id="gdlr-core-sidebar-wrapper-1"
          >
            <div className="gdlr-core-pbf-sidebar-container gdlr-core-line-height-0 clearfix gdlr-core-js gdlr-core-container">
              <div className="gdlr-core-pbf-sidebar-content gdlr-core-column-45 gdlr-core-pbf-sidebar-padding gdlr-core-line-height gdlr-core-column-extend-left green_back_second">
                <div className="gdlr-core-pbf-sidebar-content-inner">
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr">
                            <div
                              className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round"
                              style={{
                                borderWidth: "0px",
                                borderRadius: "20px",
                                MozBorderRadius: "20px",
                                WebkitBorderRadius: "20px",
                              }}
                            >
                              <img
                                src={KingIndoorImage}
                                alt=""
                                width="1150"
                                height="490"
                                title="Deluxe King Room with Indoor Spa Bath at Banana Bunks Mirissa"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
                    id="gdlr-core-column-1"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{
                        margin: "0px 0px 0px 0px",
                        padding: "10px 0px 20px 0px",
                      }}
                    >
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="tourmaster-room-title-item tourmaster-item-mglr tourmaster-item-pdb clearfix"
                            style={{ paddingBottom: "35px" }}
                          >
                            <h3
                              className="tourmaster-room-title-item-title"
                              style={{ color: "#eeb85e" }}
                            >
                              Deluxe King Room with Indoor Spa Bath
                            </h3>
                            <div className="tourmaster-room-title-item-caption yellowcolor">
                              Room Features
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                            <div className="gdlr-core-divider-line gdlr-core-skin-divider"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
                    id="gdlr-core-column-2"
                  >
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                            style={{ paddingBottom: "20px" }}
                          >
                            <div className="gdlr-core-column-service-media gdlr-core-media-icon">
                              <i
                                className="gdlr-icon-double-bed2"
                                style={{
                                  fontSize: "33px",
                                  lineHeight: "33px",
                                  width: "33px",
                                  color: "#eeb85e",
                                }}
                              ></i>
                            </div>
                            <div className="gdlr-core-column-service-content-wrapper">
                              <div className="gdlr-core-column-service-title-wrap">
                                <h3
                                  className="gdlr-core-column-service-title gdlr-core-skin-title yellowcolor"
                                  style={{
                                    fontSize: "19px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Bed
                                </h3>
                                <div
                                  className="gdlr-core-info-font gdlr-core-skin-caption"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    fontStyle: "normal",
                                    marginTop: "0px",
                                    color: "#eeb85e",
                                  }}
                                >
                                  1 King and 1 Single Bed
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20"
                    id="gdlr-core-column-3"
                  >
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                            style={{ paddingBottom: "20px" }}
                          >
                            <div
                              className="gdlr-core-column-service-media gdlr-core-media-icon"
                              style={{ marginTop: "0px", marginRight: "26px" }}
                            >
                              <i
                                className="gdlr-icon-group"
                                style={{
                                  fontSize: "40px",
                                  lineHeight: "40px",
                                  width: "40px",
                                  color: "#eeb85e",
                                }}
                              ></i>
                            </div>
                            <div className="gdlr-core-column-service-content-wrapper">
                              <div className="gdlr-core-column-service-title-wrap">
                                <h3
                                  className="gdlr-core-column-service-title gdlr-core-skin-title yellowcolor"
                                  style={{
                                    fontSize: "19px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Max Guest
                                </h3>
                                <div
                                  className="gdlr-core-info-font gdlr-core-skin-caption yellowcolor"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    fontStyle: "normal",
                                    marginTop: "0px",
                                  }}
                                >
                                  3 Guests
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-20">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js"></div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
                    id="gdlr-core-column-4"
                  >
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-column-service-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-column-service-icon-left gdlr-core-with-caption gdlr-core-item-pdlr"
                            style={{ paddingBottom: "20px" }}
                          >
                            <div className="gdlr-core-column-service-media gdlr-core-media-icon">
                              <i
                                className="gdlr-icon-resize"
                                style={{
                                  fontSize: "34px",
                                  lineHeight: "34px",
                                  width: "34px",
                                  color: "#eeb85e",
                                }}
                              ></i>
                            </div>
                            <div className="gdlr-core-column-service-content-wrapper">
                              <div className="gdlr-core-column-service-title-wrap">
                                <h3
                                  className="gdlr-core-column-service-title gdlr-core-skin-title yellowcolor"
                                  style={{
                                    fontSize: "19px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Room Space
                                </h3>
                                <div
                                  className="gdlr-core-info-font gdlr-core-skin-caption yellowcolor"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    fontStyle: "normal",
                                    marginTop: "0px",
                                  }}
                                >
                                  34 sqm
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-20">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js"></div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
                    id="gdlr-core-column-6"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{ padding: "10px 0px 0px 0px" }}
                    >
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                            <div
                              className="gdlr-core-text-box-item-content yellowcolor"
                              style={{
                                fontSize: "18px",
                                textTransform: "none",
                              }}
                            >
                              <p>
                                The spacious double room offers air
                                conditioning, a private entrance, as well as a
                                private bathroom featuring a bath and a shower.
                                The unit offers 1 bed.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first"
                    id="gdlr-core-column-7"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js"
                      style={{
                        margin: "0px 0px 0px 0px",
                        padding: "0px 0px 25px 0px",
                      }}
                    >
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align">
                            <div className="gdlr-core-divider-line gdlr-core-skin-divider"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                            style={{ paddingBottom: "40px" }}
                          >
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3
                                className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                style={{
                                  fontSize: "25px",
                                  fontWeight: 500,
                                  letterSpacing: "0px",
                                  textTransform: "none",
                                }}
                              >
                                Room Amenities
                                <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
                    id="gdlr-core-column-8"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow"
                      style={{
                        margin: "0px 10px 20px 20px",
                        padding: "25px 0px 0px 10px",
                        borderRadius: "20px 20px 20px 20px",
                        MozBorderRadius: "20px 20px 20px 20px",
                        WebkitBorderRadius: "20px 20px 20px 20px",
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: "20px 20px 20px 20px",
                          MozBorderRadius: "20px 20px 20px 20px",
                          WebkitBorderRadius: "20px 20px 20px 20px",
                          borderWidth: "1px 1px 1px 1px",
                          borderColor: "#eeb85e",
                          borderStyle: "solid",
                        }}
                      ></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft"
                            style={{ paddingBottom: "10px" }}
                          >
                            <div
                              className="gdlr-core-title-item-left-icon"
                              style={{
                                margin: "-12px 16px 0px 0px",
                                fontSize: "35px",
                              }}
                            >
                              <i
                                className="gdlr-icon-watch-tv"
                                style={{ color: "#eeb85e" }}
                              ></i>
                            </div>
                            <div className="gdlr-core-title-item-left-icon-wrap">
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    letterSpacing: "0px",
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  TV
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20"
                    id="gdlr-core-column-9"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow"
                      style={{
                        margin: "0px 10px 20px 10px",
                        padding: "25px 0px 0px 10px",
                        borderRadius: "20px 20px 20px 20px",
                        MozBorderRadius: "20px 20px 20px 20px",
                        WebkitBorderRadius: "20px 20px 20px 20px",
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: "20px 20px 20px 20px",
                          MozBorderRadius: "20px 20px 20px 20px",
                          WebkitBorderRadius: "20px 20px 20px 20px",
                          borderWidth: "1px 1px 1px 1px",
                          borderColor: "#eeb85e",
                          borderStyle: "solid",
                        }}
                      ></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft"
                            style={{ paddingBottom: "10px" }}
                          >
                            <div
                              className="gdlr-core-title-item-left-icon"
                              style={{
                                margin: "-12px 15px 0px 0px",
                                fontSize: "35px",
                              }}
                            >
                              <i
                                className="gdlr-icon-wifi-signal"
                                style={{ color: "#eeb85e" }}
                              ></i>
                            </div>
                            <div className="gdlr-core-title-item-left-icon-wrap">
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    letterSpacing: "0px",
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Free Wifi
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20"
                    id="gdlr-core-column-10"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow"
                      style={{
                        margin: "0px 10px 20px 10px",
                        padding: "25px 0px 0px 10px",
                        borderRadius: "20px 20px 20px 20px",
                        MozBorderRadius: "20px 20px 20px 20px",
                        WebkitBorderRadius: "20px 20px 20px 20px",
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: "20px 20px 20px 20px",
                          MozBorderRadius: "20px 20px 20px 20px",
                          WebkitBorderRadius: "20px 20px 20px 20px",
                          borderWidth: "1px 1px 1px 1px",
                          borderColor: "#eeb85e",
                          borderStyle: "solid",
                        }}
                      ></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft"
                            style={{ paddingBottom: "10px" }}
                          >
                            <div
                              className="gdlr-core-title-item-left-icon"
                              style={{
                                margin: "-12px 15px 0px 0px",
                                fontSize: "35px",
                              }}
                            >
                              <i
                                className="gdlr-icon-air-conditioner1"
                                style={{ color: "#eeb85e" }}
                              ></i>
                            </div>
                            <div className="gdlr-core-title-item-left-icon-wrap">
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    letterSpacing: "0px",
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Air Conditioning
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
                    id="gdlr-core-column-14"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow"
                      style={{
                        margin: "0px 10px 20px 20px",
                        padding: "25px 0px 0px 10px",
                        borderRadius: "20px 20px 20px 20px",
                        MozBorderRadius: "20px 20px 20px 20px",
                        WebkitBorderRadius: "20px 20px 20px 20px",
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: "20px 20px 20px 20px",
                          MozBorderRadius: "20px 20px 20px 20px",
                          WebkitBorderRadius: "20px 20px 20px 20px",
                          borderWidth: "1px 1px 1px 1px",
                          borderColor: "#eeb85e",
                          borderStyle: "solid",
                        }}
                      ></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft"
                            style={{ paddingBottom: "10px" }}
                          >
                            <div
                              className="gdlr-core-title-item-left-icon"
                              style={{
                                margin: "-12px 16px 0px 0px",
                                fontSize: "35px",
                              }}
                            >
                              <i
                                className="gdlr-icon-telephone"
                                style={{ color: "#eeb85e" }}
                              ></i>
                            </div>
                            <div className="gdlr-core-title-item-left-icon-wrap">
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    letterSpacing: "0px",
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Phone
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20"
                    id="gdlr-core-column-15"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow"
                      style={{
                        margin: "0px 10px 20px 10px",
                        padding: "25px 0px 0px 10px",
                        borderRadius: "20px 20px 20px 20px",
                        MozBorderRadius: "20px 20px 20px 20px",
                        WebkitBorderRadius: "20px 20px 20px 20px",
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: "20px 20px 20px 20px",
                          MozBorderRadius: "20px 20px 20px 20px",
                          WebkitBorderRadius: "20px 20px 20px 20px",
                          borderWidth: "1px 1px 1px 1px",
                          borderColor: "#eeb85e",
                          borderStyle: "solid",
                        }}
                      ></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft"
                            style={{ paddingBottom: "10px" }}
                          >
                            <div
                              className="gdlr-core-title-item-left-icon"
                              style={{
                                margin: "-12px 15px 0px 0px",
                                fontSize: "35px",
                              }}
                            >
                              <i
                                className="gdlr-icon-hair-dryer1"
                                style={{ color: "#eeb85e" }}
                              ></i>
                            </div>
                            <div className="gdlr-core-title-item-left-icon-wrap">
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    letterSpacing: "0px",
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Hair Dryer
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="gdlr-core-pbf-column gdlr-core-column-20"
                    id="gdlr-core-column-21"
                  >
                    <div
                      className="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-move-up-with-shadow"
                      style={{
                        margin: "0px 10px 20px 10px",
                        padding: "25px 0px 0px 10px",
                        borderRadius: "20px 20px 20px 20px",
                        MozBorderRadius: "20px 20px 20px 20px",
                        WebkitBorderRadius: "20px 20px 20px 20px",
                      }}
                    >
                      <div
                        className="gdlr-core-pbf-background-wrap"
                        style={{
                          borderRadius: "20px 20px 20px 20px",
                          MozBorderRadius: "20px 20px 20px 20px",
                          WebkitBorderRadius: "20px 20px 20px 20px",
                          borderWidth: "1px 1px 1px 1px",
                          borderColor: "#eeb85e",
                          borderStyle: "solid",
                        }}
                      ></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div
                            className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr pleft"
                            style={{ paddingBottom: "10px" }}
                          >
                            <div
                              className="gdlr-core-title-item-left-icon"
                              style={{
                                margin: "-12px 15px 0px 0px",
                                fontSize: "35px",
                              }}
                            >
                              <i
                                className="gdlr-icon-food-service-copy"
                                style={{ color: "#eeb85e" }}
                              ></i>
                            </div>
                            <div className="gdlr-core-title-item-left-icon-wrap">
                              <div className="gdlr-core-title-item-title-wrap">
                                <h3
                                  className="gdlr-core-title-item-title gdlr-core-skin-title class-test"
                                  style={{
                                    fontSize: "17px",
                                    fontWeight: 500,
                                    letterSpacing: "0px",
                                    textTransform: "none",
                                    color: "#eeb85e",
                                  }}
                                >
                                  Room Service
                                  <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <style>
                {`
                  .booking-sidebar-custom .tourmaster-custom-amount-selection-wrap {
                    display: none !important;
                  }
                  .booking-sidebar-custom .tourmaster-custom-datepicker-wrap {
                    display: none !important;
                  }
                  .booking-sidebar-custom .tourmaster-custom-amount-display,
                  .booking-sidebar-custom .tourmaster-custom-start-date,
                  .booking-sidebar-custom .tourmaster-custom-end-date {
                    cursor: default !important;
                    pointer-events: none !important;
                  }
                `}
              </style>
              <div className="gdlr-core-pbf-sidebar-right gdlr-core-column-extend-right hotale-sidebar-area gdlr-core-column-15 gdlr-core-pbf-sidebar-padding gdlr-core-line-height bookingwidth booking-sidebar-custom">
                <div className="gdlr-core-sidebar-item gdlr-core-item-pdlr">
                  <div className="tourmaster-room-booking-bar-wrap">
                    <div
                      className="tourmaster-room-booking-bar-title greencolor"
                      style={{
                        backgroundColor: "#eeb85e",
                        paddingBottom: "15px",
                        paddingTop: "15px",
                        borderRadius: "10px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                        color: "#333",
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        fontSize: "18px",
                      }}
                    >
                      Book Your Room
                    </div>
                    <div
                      className="tourmaster-room-booking-bar-content"
                      style={{ padding: "20px 0" }}
                    >
                      <div
                        className="tourmaster-room-booking-wrap tourmaster-active"
                        data-room-tab="booking"
                      >
                        <form
                          className="tourmaster-room-booking-form clearfix"
                          id="tourmaster-room-booking-form"
                          action="https://app.channelmanager.com.au/booknow/Chain/kent-chain-135"
                          method="POST"
                        >
                          <div
                            className="tourmaster-room-date-selection tourmaster-vertical"
                            style={{ paddingTop: "0" }}
                          >
                            <div
                              className="tourmaster-custom-start-date gdlr-core-skin-e-background"
                              style={{
                                backgroundColor: "#eeb85e",
                                borderRadius: "10px",
                                marginBottom: "15px",
                                padding: "15px 20px",
                              }}
                            >
                              <div
                                className="tourmaster-head gdlr-core-skin-e-content"
                                style={{
                                  fontSize: "16px",
                                  color: "#333",
                                  marginBottom: "5px",
                                }}
                              >
                                Check In
                              </div>
                              <div
                                className="tourmaster-tail gdlr-core-skin-e-content"
                                style={{
                                  fontSize: "18px",
                                  color: "#333",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                {formattedDate}
                                <span>▼</span>
                              </div>
                              <input
                                type="hidden"
                                name="start_date"
                                id="datePicker"
                                value={dateFormatStart}
                              />
                            </div>
                            <div
                              className="tourmaster-custom-end-date gdlr-core-skin-e-background"
                              style={{
                                backgroundColor: "#eeb85e",
                                borderRadius: "10px",
                                marginBottom: "15px",
                                padding: "15px 20px",
                              }}
                            >
                              <div
                                className="tourmaster-head gdlr-core-skin-e-content"
                                style={{
                                  fontSize: "16px",
                                  color: "#333",
                                  marginBottom: "5px",
                                }}
                              >
                                Check Out
                              </div>
                              <div
                                className="tourmaster-tail gdlr-core-skin-e-content"
                                style={{
                                  fontSize: "18px",
                                  color: "#333",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                {formattedDate}
                                <span>▼</span>
                              </div>
                              <input
                                type="hidden"
                                name="end_date"
                                id="datePickertomorrow"
                                value={dateFormatEnd}
                              />
                            </div>
                          </div>
                          <div className="tourmaster-room-amount-selection">
                            <div
                              className="tourmaster-custom-amount-display gdlr-core-skin-e-background"
                              style={{
                                backgroundColor: "#eeb85e",
                                borderRadius: "10px",
                                marginBottom: "15px",
                                padding: "15px 20px",
                              }}
                            >
                              <div
                                className="tourmaster-head gdlr-core-skin-e-content"
                                style={{
                                  fontSize: "16px",
                                  color: "#333",
                                  marginBottom: "5px",
                                }}
                              >
                                Room
                              </div>
                              <div
                                className="tourmaster-tail gdlr-core-skin-e-content"
                                style={{
                                  fontSize: "18px",
                                  color: "#333",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                {roomAmount}
                                <span>▼</span>
                              </div>
                            </div>
                            <input
                              type="hidden"
                              name="room_amount"
                              value={roomAmount}
                            />
                          </div>
                          <div className="tourmaster-room-booking-guest-selection tourmaster-one">
                            <div className="tourmaster-room-amount-selection">
                              <div
                                className="tourmaster-custom-amount-display gdlr-core-skin-e-background"
                                style={{
                                  backgroundColor: "#eeb85e",
                                  borderRadius: "10px",
                                  marginBottom: "15px",
                                  padding: "15px 20px",
                                }}
                              >
                                <div
                                  className="tourmaster-head gdlr-core-skin-e-content"
                                  style={{
                                    fontSize: "16px",
                                    color: "#333",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Guests
                                </div>
                                <div
                                  className="tourmaster-tail gdlr-core-skin-e-content"
                                  style={{
                                    fontSize: "18px",
                                    color: "#333",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  ADULTS {adults} CHILDREN {children}
                                  <span>▼</span>
                                </div>
                              </div>
                              <input
                                type="hidden"
                                name="adult[]"
                                value={adults}
                              />
                              <input
                                type="hidden"
                                name="children[]"
                                value={children}
                              />
                            </div>
                          </div>
                          <input type="hidden" name="room_id" value="15031" />
                          <input type="hidden" name="post_type" value="room" />
                          <input
                            type="submit"
                            className="tourmaster-room-button tourmaster-full"
                            value="BOOK NOW"
                            style={{
                              backgroundColor: "#eeb85e",
                              borderRadius: "10px",
                              padding: "15px 20px",
                              color: "#333",
                              fontWeight: "bold",
                              textTransform: "uppercase",
                              border: "none",
                              cursor: "pointer",
                              width: "100%",
                              fontSize: "18px",
                            }}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gdlr-core-pbf-wrapper" id="gdlr-core-wrapper-2">
                <div className="gdlr-core-pbf-background-wrap"></div>
                <div className="gdlr-core-pbf-wrapper-content gdlr-core-js green_back_second_gallery">
                  <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full">
                    <div className="gdlr-core-pbf-element">
                      <div className="gdlr-core-gallery-item gdlr-core-item-pdb clearfix gdlr-core-gallery-item-style-scroll gdlr-core-item-pdlr">
                        <div className="gdlr-core-sly-slider" ref={sliderRef}>
                          <ul
                            className="slides"
                            ref={slidesRef}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "nowrap",
                              transform: `translateX(${translate}px)`,
                              transition: isDragging
                                ? "none"
                                : "transform 0.3s ease-out",
                            }}
                          >
                            {galleryImages.map((image, index) => (
                              <li
                                key={index}
                                className="gdlr-core-gallery-list gdlr-core-item-mglr"
                                style={{
                                  marginLeft: "5px",
                                  marginRight: "5px",
                                }}
                              >
                                <div
                                  className="gdlr-core-media-image"
                                  style={{ height: "500px" }}
                                >
                                  <a
                                    className="gdlr-core-lightgallery gdlr-core-js"
                                    href={image.src}
                                    data-lightbox-group="gdlr-core-img-group-1"
                                  >
                                    <img
                                      src={image.src}
                                      alt={image.alt}
                                      width="2200"
                                      height="1467"
                                      title={image.title}
                                    />
                                  </a>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="gdlr-core-sly-scroll">
                          <div className="gdlr-core-sly-scroll-handle"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Kingroomin;
